export const isPhoneNumber = (text: string): boolean => {
  if (text.match(/^(?:\+?\d{1,3}[ -]?)?\d{1,4}(?:[ -]?\d{1,4}){1,3}$/)) {
    return true;
  } else {
    return false;
  }
};
